module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"candidate":"Candidate","phone":"Phone","email":"Email","downloadResume":"Download resume"}}')
  delete Component.options._Ctor
}
